<template>
  <section class="about-popular-gifts">
    <div class="about-popular-gifts__content">
      <div class="about-popular-gifts__title-image mb-20">
        <img
          class="about-popular-gifts__title-image--item"
          src="../../../../../../images/bulk_personal_orders/about/cracker1.png"
          alt=""
        />
        <img
          class="about-popular-gifts__title-image--item"
          src="../../../../../../images/bulk_personal_orders/about/cracker2.png"
          alt=""
        />
      </div>
      <h3 class="about-popular-gifts__title">
        <span class="about-popular-gifts__title--wrap">
          <span>まとめてオーダーで</span><span>人気のギフト</span>
        </span>
      </h3>
      <div class="about-popular-gifts__description">
        <p class="about-popular-gifts__description--text">
          <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
          <span>ギフトを受け取った方が、豊富なラインナップから</span><span>好きな商品を選べる「giftee Box」シリーズ。</span>
        </p>
        <p class="about-popular-gifts__description--text">
          <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
          <span>お相手の好みに左右されないので、</span><span>大人数に贈りたい時は特に便利なギフトです。</span>
        </p>
      </div>
      <div class="about-popular-gifts__giftee-boxes">
        <div class="about-popular-gifts__giftee-boxes--image">
          <img
            class="about-popular-gifts__giftee-boxes--image--content"
            src="../../../../../../images/bulk_personal_orders/about/giftee_box_ui.png"
            alt="giftee Boxシリーズ ギフト交換画面"
          />
          <p class="about-popular-gifts__giftee-boxes--image--caption minimal">
            ※画像はイメージです
          </p>
        </div>
        <div class="about-popular-gifts__giftee-boxes--items">
          <div class="about-popular-gifts__giftee-boxes--items--wrapper">
            <img
              src="../../../../../../images/bulk_personal_orders/about/giftee_box_covers/giftee_box_cover1.png"
              alt="giftee Spring Box"
            />
            <img
              src="../../../../../../images/bulk_personal_orders/about/giftee_box_covers/giftee_box_cover2.png"
              alt="giftee Cafe Box"
            />
            <img
              src="../../../../../../images/bulk_personal_orders/about/giftee_box_covers/giftee_box_cover3.png"
              alt="giftee Foodie Box"
            />
            <img
              src="../../../../../../images/bulk_personal_orders/about/giftee_box_covers/giftee_box_cover4.png"
              alt="giftee Box for バレンタイン"
            />
            <img
              src="../../../../../../images/bulk_personal_orders/about/giftee_box_covers/giftee_box_cover5.png"
              alt="giftee Box for ハロウィン"
            />
            <img
              src="../../../../../../images/bulk_personal_orders/about/giftee_box_covers/giftee_box_cover6.png"
              alt="giftee Box for クリスマス"
            />
          </div>
          <div class="about-popular-gifts__giftee-boxes--items--button">
            <a class="btn btn--secondary" href="/items?category_id=20">
              giftee Boxを見る
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.about-popular-gifts {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $white;

  &__content {
    width: 100%;
    max-width: 1440px;
    padding: 96px 72px;
    box-sizing: border-box;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 64px 56px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      padding: 64px 24px;
    }
  }

  &__title {
    display: inline-block;
    color: $primary;
    font-weight: bold;
    font-size: 4.4rem;
    line-height: 1.29;
    position: relative;

    @media all and (max-width: ($pc-width - 1)) {
      font-size: 2.8rem;
    }

    &::before,
    &::after {
      content: '';
      display: inline-block;
      width: 138px;
      height: 145px;
      background-position: center;
      background-size: contain;
      position: absolute;

      @media all and (max-width: ($pc-width - 1)) {
        width: 72px;
        height: 76px;
        top: 0;
      }

      @media all and (max-width: ($base-contents-width  - 1)) {
        display: none;
      }
    }

    &::before {
      left: -138px; // 画像の横幅分、左へ移動
      background-image: url('../../../../../../images/bulk_personal_orders/about/cracker1.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;

      @media all and (max-width: ($pc-width - 1)) {
        left: -72px; // 画像の横幅分、左へ移動
      }
    }

    &::after {
      background-image: url('../../../../../../images/bulk_personal_orders/about/cracker2.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }

    &--wrap {
      display: inline-block;
      margin: 0 12px;

      @media all and (max-width: ($pc-width - 1)) {
        margin: 0 16px;
      }

      @media all and (max-width: ($base-contents-width - 1)) {
        margin: 0;
      }

      & > span {
        display: block;
      }
    }
  }

  &__title-image {
    display: none;

    @media all and (max-width: ($base-contents-width - 1)) {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 57px;
    }

    &--item {
      width: 72px;
      height: 76px;
      object-fit: contain;
    }
  }

  &__description {
    margin: 69px 0 55px;

    @media all and (max-width: ($pc-width - 1)) {
      margin: 32px 0;
    }
    @media all and (max-width: ($base-contents-width - 1)) {
      margin: 16px 0 24px;
    }

    &--text {
      color: $black;
      font-size: 2rem;
      line-height: 1.4;

      @media all and (max-width: ($pc-width - 1)) {
        font-size: 1.4rem;
        line-height: 1.6;
        & > span {
          display: block;
        }
      }
    }
  }

  &__giftee-boxes {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: 24px;

    @media all and (max-width: ($pc-width - 1)) {
      align-items: center;
      flex-direction: column;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      gap: 48px;
    }

    &--image {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      gap: 15px;

      &--content {
        max-width: 326px;
        width: 100%;
        object-fit: contain;

        @media all and (max-width: ($pc-width - 1)) {
          max-width: 465px;
        }

        @media all and (max-width: ($base-contents-width - 1)) {
          padding-right: 64px;
          padding-left: 64px;
          box-sizing: border-box;
        }
      }

      &--caption {
        font-size: 1.2rem;
      }
    }

    &--items {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      gap: 40px;

      @media all and (max-width: ($pc-width - 1)) {
        gap: 32px;
      }

      @media all and (max-width: ($base-contents-width - 1)) {
        gap: 24px;
      }

      &--wrapper {
        display: grid;
        grid-template-columns: repeat(3, 160px);
        gap: 8px;

        @media all and (max-width: ($pc-width - 1)) {
          grid-template-columns: repeat(3, 213px);
        }

        @media all and (max-width: ($base-contents-width - 1)) {
          grid-template-columns: repeat(3, 1fr);
        }

        & > img {
          width: 100%;
          object-fit: contain;
        }
      }

      &--button {
        width: 100%;

        & > a {
          width: 280px;
          display: inline-block;

          @media all and (max-width: ($pc-width - 1)) {
            max-width: 327px;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
